import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RulesRoutingModule } from './rules-routing.module';
import { RulesComponent } from './rules.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import {TableModule} from 'primeng/table';
import {RadioButtonModule} from 'primeng/radiobutton';
import {CheckboxModule} from 'primeng/checkbox';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RulesRoutingModule,
    TableModule,
    RadioButtonModule,
    CheckboxModule,
    ButtonModule,
    ToastModule,
    NgbModule,
    FormsModule,
    SharedModule,
    TranslateModule
  ],
  declarations: [RulesComponent,],
  
  providers: []
})
export class RulesModule { }
